var map = {
	".": 81222,
	"./": 81222,
	"./DailyMotion": 16380,
	"./DailyMotion.js": 16380,
	"./Facebook": 19813,
	"./Facebook.js": 19813,
	"./FilePlayer": 982,
	"./FilePlayer.js": 982,
	"./Kaltura": 14663,
	"./Kaltura.js": 14663,
	"./Mixcloud": 48496,
	"./Mixcloud.js": 48496,
	"./Mux": 41813,
	"./Mux.js": 41813,
	"./SoundCloud": 63579,
	"./SoundCloud.js": 63579,
	"./Streamable": 30724,
	"./Streamable.js": 30724,
	"./Twitch": 48674,
	"./Twitch.js": 48674,
	"./Vidyard": 84744,
	"./Vidyard.js": 84744,
	"./Vimeo": 97790,
	"./Vimeo.js": 97790,
	"./Wistia": 72722,
	"./Wistia.js": 72722,
	"./YouTube": 54595,
	"./YouTube.js": 54595,
	"./index": 81222,
	"./index.js": 81222,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players": 81222,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/": 81222,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion": 16380,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion.js": 16380,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook": 19813,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook.js": 19813,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer": 982,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer.js": 982,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura": 14663,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura.js": 14663,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud": 48496,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud.js": 48496,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux": 41813,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux.js": 41813,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud": 63579,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud.js": 63579,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable": 30724,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable.js": 30724,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch": 48674,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch.js": 48674,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard": 84744,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard.js": 84744,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo": 97790,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo.js": 97790,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia": 72722,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia.js": 72722,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube": 54595,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube.js": 54595,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index": 81222,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index.js": 81222
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85456;